// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__3YOIT","text":"LimitedAccessBanner_text__3AEnu","button":"LimitedAccessBanner_button__3fQ7t"};